/**
 * /frontend/src/features/analytics/hooks/useQueueAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getQueuePerformance, getQueuePerformanceTrend } from '../api/queueAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads queue analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useQueueAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, zoneId, sectionId, granularity, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [performance, trend] = await Promise.all([
      getQueuePerformance(request, storeToken, storeUuid, startDate, endDate, zoneId, sectionId),
      getQueuePerformanceTrend(request, storeToken, storeUuid, startDate, endDate, granularity),
    ]);
    return { performance, trend };
  }, [endDate, granularity, request, sectionId, startDate, storeToken, storeUuid, zoneId]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useQueueAnalytics', refreshSignal);

  return useMemo(() => resource, [resource]);
};

export default useQueueAnalytics;
